import React, { createContext, useCallback, useContext, useMemo, useState } from "react";
import { toast } from "react-toastify";
import { fetchAIScheduleMatrixGroupTableAndFilterSchema } from "model/AIScheduleMatrixGroupModel";
import { useCommonFilterOptions } from "./CommonFilterOptionsContext";

const AIScheduleMatrixGroupContext = createContext();

export const AIScheduleMatrixGroupProvider = ({ children }) => {
  const { fetchMetadataSchema } = useCommonFilterOptions();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [aiScheduleMatrixGroupContextData, setAIScheduleMatrixGroupContextData] =
    useState();

  const fetchAIScheduleMatrixGroupContextData = useCallback(async () => {
    setLoading(true);
    try {
      const response = await fetchMetadataSchema(
        "metadata:aiScheduleMatrixGroup",
        () => fetchAIScheduleMatrixGroupTableAndFilterSchema([])
      );
      if (response?.success) {
        setAIScheduleMatrixGroupContextData(response?.data);
      }
    } catch (err) {
      toast.error(err);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [fetchMetadataSchema]);

  const value = useMemo(
    () => ({
      fetchAIScheduleMatrixGroupContextData,
      aiScheduleMatrixGroupContextData,
      loading,
      error,
    }),
    [
      fetchAIScheduleMatrixGroupContextData,
      aiScheduleMatrixGroupContextData,
      loading,
      error,
    ]
  );

  return (
    <AIScheduleMatrixGroupContext.Provider value={value}>
      {children}
    </AIScheduleMatrixGroupContext.Provider>
  );
};

export const useAIScheduleMatrixGroupContext = () =>
  useContext(AIScheduleMatrixGroupContext);
